import React, { useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import './QuestionRadioMulti.css'

const QuestionRadioMulti = ({ options, callback, navCallback }) => {
  const [ radios, setRadios ] = useState(options.groups || []);

  const handleClick = (e) => {
    const name = e.target.name;
    const checkStatus = e.target.checked;
    const value = e.target.value;

    const CheckFiltered = radios.map( (o) => {     
      if(o.title === name) {
        o.options.map( (c) => {
            c.checked = false;
          if(c.option === value)
            c.checked = checkStatus;
          return c;
        });
      }
      return o;
    });

    setRadios(CheckFiltered);
    callback(radios);
  }

  return (
    <>
      {radios ? radios.map( (item) => {
        return (
          <>
            <div className="text-center">
                <h3 className="text-xl sm:text-2xl font-bold mb-5 sm:mb-11" key={uuidv4()} >{ item.title }</h3>

                {item.options.map( (o) => (
                <div className={"inline-block relative mb-10 mr-6 ml-2"} key={uuidv4()}>
                    <input
                    onClick={handleClick}
                    className="option" 
                    key={uuidv4()}
                    type='radio'
                    defaultChecked={o.checked}
                    name={item.title} 
                    value={o.option} 
                    id={item.title + '-' + o.option}
                    />
                    <label  
                    className="text-xl sm:text-2xl font-medium" 
                    htmlFor={item.title + '-' + o.option}>
                        {o.option}
                    </label>
                </div>
                ))}
            </div>
          </>
        )
      }):null}
    </>
  );
};

export default QuestionRadioMulti;
